/// <amd-module name="Checks/ChecksOverview/Telemetry" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { IVssPerformanceService } from "VSS/Platform/Performance";

export function publishTelemetry(pageContext: IVssPageContext, featureName: string, properties: { [key: string]: string } = {}): void {
    const telemetryService = pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
    telemetryService.publishEvent(Area, featureName, properties);
}

export function markTimeToInteractive(pageContext: IVssPageContext): void {
    let perfirmanceService = pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
    perfirmanceService.markTimeToInteractive(Area, ScenarioNames.ChecksPageLoad);
}

const Area = "PipelineChecks";

export namespace FeatureNames {
    export const ChecksPage = "Checks_Page";
    export const AddCheck = "Add_Check";
    export const EditCheck = "Edit_Check";
    export const DeleteCheck = "DeleteCheck";
}

export namespace ScenarioNames {
    export const ChecksPageLoad = "Pipelines.PipelineChecks";
}